<script lang="ts" setup name="OrganisationPortCallsSchedule">
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';

import { usePortCallsMilestones } from '~/features/usePortCallsMilestones';
import { useService } from '~/features/useService';

import Service from '~/services/Service.js';

import Card from '~/components/Card.vue';
import ServiceCard from '~/components/ServiceCard.vue';
import VoyageTracker from '~/components/VoyageTracker.vue';

import type { IVoyageTrackerStep } from '~/types';
import {
  type IPortsCallsPort,
  type IPortsCallsScheduleResponse,
} from '~/types/organisationPortCalls';

const { organisationId, portCallId } = defineProps<{
  organisationId: OrganisationId;
  portCallId: string;
}>();

const cardTitle = computed(() => `Schedule at ${portName.value}`);

const router = useRouter();

const portName = ref('');
const milestones = ref<IPortsCallsPort[]>([]);

const voyageTrackerMilestones = computed<IVoyageTrackerStep[]>(() =>
  usePortCallsMilestones({
    ports: milestones.value,
    organisationId,
    router,
  }),
);

const getPortName = (ports: IPortsCallsPort[]) => {
  const currentPort = ports.find((port) => port.state === 'current');
  portName.value = currentPort?.portName ?? '';
};

const serviceState = useService(
  Service.organisation(organisationId).portCallsCalls().schedule(portCallId),
  ({ data }: { data: IPortsCallsScheduleResponse }) => {
    if (!data.ports.length) return false;
    milestones.value = data.ports;
    getPortName(data.ports);
    return true;
  },
);
</script>

<template>
  <ServiceCard v-bind="serviceState" styled>
    <Card :title="cardTitle" data-testid="portCallsMilestones">
      <div class="-mt-4 max-h-[390px] overflow-y-auto">
        <VoyageTracker
          v-for="milestone in voyageTrackerMilestones"
          :key="milestone.id"
          :data-testid="milestone.id"
          v-bind="milestone"
        />
      </div>
    </Card>
  </ServiceCard>
</template>
